export default __webpack_public_path__ + "static/media/google.15737972.svg";